import Vue from 'vue'
import VueRouter from 'vue-router'
import wx from 'weixin-js-sdk'
import store from '@/store'
import layout from '@/layout/index.vue'
import {wechatUrlParse} from '@/utils/tool'
import {token} from '@/utils/localStorage'

Vue.use(VueRouter)

const whiteList = [
  {
    path: '/annualMeeting/login',
    needLogin: false
  },
  {
    path: '/annualMeeting/index',
    needLogin: false
  },
  {
    path: '/annualMeeting/apply_total',
    needLogin: true
  },
  {
    path: '/annualMeeting/apply1',
    needLogin: true
  },
  {
    path: '/annualMeeting/apply2',
    needLogin: true
  },
  {
    path: '/annualMeeting/success',
    needLogin: true
  },
  {
    path: '/annualMeeting/mine',
    needLogin: true
  },
  {
    path: '/annualMeeting/photo',
    needLogin: true
  },
  {
    path: '/annualMeeting/photo-item',
    needLogin: true
  },
  {
    path: '/annualMeeting/mark',
    needLogin: true
  },
  {
    path: '/annualMeeting/testDrive',
    needLogin: true
  },
  {
    path: '/annualMeeting/notice',
    needLogin: true
  },
  {
    path: '/annualMeeting/noticeDetail',
    needLogin: true
  },
  {
    path: '/annualMeeting/contact',
    needLogin: true
  },
  {
    path: '/beautifyPhoto/annualMeeting',
    needLogin: true
  },
  {
    path: '/driver/recruitment',
    needLogin: false
  },
  {
    path: '/ai/annualMeeting',
    needLogin: false
  },
  {
    path: '/photoSearch/annualMeeting',
    needLogin: true
  },
  {
    path: '/photoSearch/agreement',
    needLogin: true
  },
  {
    path: '/questionnaire/annualMeeting',
    needLogin: true
  }
]

const routes = [
  {
    path: '/',
    component: layout,
    // redirect: '/annualMeeting/index',
    redirect: '/home',
    children: [
      {
        path: '/home',
        component: () => import('@/views/home/index.vue')
      },
      {
        path: '/calendar',
        component: () => import('@/views/calendar/index.vue')
      },
      {
        path: '/calendarList',
        component: () => import('@/views/calendar/list.vue')
      }
    ]
  },
  {
    path: '/vote',
    component: () => import('@/views/vote/layout.vue'),
    redirect: '/voteIndex',
    children: [
      {
        path: '/voteIndex',
        component: () => import('@/views/vote/index.vue')
      },
      {
        path: '/voteSignUp',
        component: () => import('@/views/vote/signUp.vue')
      },
      {
        path: '/voteSignUpList',
        component: () => import('@/views/vote/signUpList.vue')
      },
      {
        path: '/voteSignUpDetail',
        component: () => import('@/views/vote/signUpDetail.vue')
      },
      {
        path: '/voteDetail',
        component: () => import('@/views/vote/detail.vue')
      },
      {
        path: '/voteRanking',
        component: () => import('@/views/vote/ranking.vue')
      }
    ]
  },
  {
    path: '/voteRankingDetail',
    component: () => import('@/views/vote/rankingDetail.vue')
  },
  {
    path: '/calendarAdd',
    component: () => import('@/views/calendar/add.vue')
  },
  {
    path: '/scheduleList',
    component: () => import('@/views/schedule/list.vue')
  },
  {
    path: '/scheduleAdd',
    component: () => import('@/views/schedule/add.vue')
  },
  {
    path: '/offline',
    component: () => import('@/views/detail/offline.vue')
  },
  {
    path: '/onLine',
    component: () => import('@/views/detail/onLine.vue')
  },
  {
    path: '/weixin',
    component: () => import('@/views/weixin/index.vue')
  },
  {
    path: '/annualMeeting',
    component: () => import('@/layout/TabLayout.vue'),
    redirect: '/annualMeeting/index',
    children: [
      {
        path: '/annualMeeting/index',
        component: () => import('@/views/annualMeeting/index.vue'),
        meta: {
          title: '五征集团2026年全球实干家生态大会'
        }
      },
      {
        path: '/annualMeeting/apply_total',
        component: () => import('@/views/annualMeeting/apply_total.vue'),
        meta: {
          title: '报名'
        }
      },
      {
        path: '/annualMeeting/apply1',
        component: () => import('@/views/annualMeeting/apply1.vue'),
        meta: {
          title: '报名'
        }
      },
      {
        path: '/annualMeeting/apply2',
        component: () => import('@/views/annualMeeting/apply2.vue'),
        meta: {
          title: '报名'
        }
      },
      {
        path: '/annualMeeting/success',
        component: () => import('@/views/annualMeeting/success.vue')
      },
      {
        path: '/annualMeeting/mine',
        component: () => import('@/views/annualMeeting/mine.vue'),
        meta: {
          title: '我的报名'
        }
      },
      {
        path: '/annualMeeting/photo',
        component: () => import('@/views/annualMeeting/photo.vue'),
        meta: {
          title: '图片直播',
          keepAlive: true
        }
      },
      {
        path: '/annualMeeting/photo-item',
        component: () => import('@/views/annualMeeting/photoItem.vue'),
        meta: {
          title: '图片直播'
        }
      },
      {
        path: '/annualMeeting/testDrive',
        component: () => import('@/views/annualMeeting/testDrive.vue'),
        meta: {
          title: '试乘试驾'
        }
      },
      {
        path: '/annualMeeting/notice',
        component: () => import('@/views/annualMeeting/notice.vue'),
        meta: {
          title: '通知公告'
        }
      },
      {
        path: '/annualMeeting/noticeDetail',
        component: () => import('@/views/annualMeeting/noticeDetail.vue'),
        meta: {
          title: '通知公告'
        }
      },
      {
        path: '/annualMeeting/contact',
        component: () => import('@/views/annualMeeting/contact.vue'),
        meta: {
          title: '紧急联系人'
        }
      }
    ]
  },
  {
    path: '/ai',
    component: () => import('@/layout/BlankLayout.vue'),
    redirect: '/ai/annualMeeting',
    children: [
      {
        path: '/ai/annualMeeting',
        component: () => import('@/views/annualMeeting/ai.vue'),
        meta: {
          title: '五征小智'
        }
      }
    ]
  },
  {
    path: '/photoSearch',
    component: () => import('@/layout/BlankLayout.vue'),
    redirect: '/photoSearch/annualMeeting',
    children: [
      {
        path: '/photoSearch/annualMeeting',
        component: () => import('@/views/annualMeeting/photoSearch.vue'),
        meta: {
          title: '人脸搜索'
        }
      },
      {
        path: '/photoSearch/agreement',
        component: () => import('@/views/annualMeeting/photoSearchAgreement.vue'),
        meta: {
          title: '人脸搜索'
        }
      }
    ]
  },
  {
    path: '/questionnaire',
    component: () => import('@/layout/BlankLayout.vue'),
    redirect: '/questionnaire/annualMeeting',
    children: [
      {
        path: '/questionnaire/annualMeeting',
        component: () => import('@/views/annualMeeting/questionnaire.vue'),
        meta: {
          title: '填写问卷'
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (!to.meta.keepAlive) {
      return {x: 0, y: 0}
    }
  }
})

let isFirstRender = true

router.beforeEach(async (to, from, next) => {
  console.log(to)
  if (whiteList.some(item => item.path === to.path)) {
    // 第一次拉取通知公告是否未读
    let isLogin = store.getters['account/isLogin']
    if (isLogin && isFirstRender) {
      isFirstRender = false
      store.dispatch('notice/getAdvertPush')
      store.dispatch('notice/getAdvertClickList')
    }

    let needLogin = whiteList.find(item => item.path === to.path).needLogin
    // 百度统计埋点
    if (to.path) {
      if (window._hmt) {
        window._hmt.push(['_trackPageview', '/#' + to.fullPath])
      }
    }
    if (needLogin && !store.getters['account/isLogin']) {
      // 跳转小程序登录
      wx.miniProgram.navigateTo({
        url: '/subPackages/home/login/index'
      })
    } else {
      // // 设置页面标题
      // document.title = to.meta.title || ''

      next()
    }
  } else {
    const href = window.location.href
    const url = wechatUrlParse(href)
    if (url) {
      // 跳转
      window.location.href = url
    } else {
      if (to.path === '/weixin') {
        next()
      } else if (!token()) {
        if (to.path === '/home' && to.query && to.query.code) {
          next()
        } else {
          next('/weixin')
        }
      } else {
        next()
      }
    }
  }
})

export default router
